// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"184":"giftCardResult","539":"giftHistory","594":"about","779":"redeemGiftCard"}[chunkId] || chunkId) + ".1.0.16.js";
};